import axios from 'axios'
import { useNavigate } from 'react-router-dom'

const API_BASE_URL = process.env.REACT_APP_API_URL

export const useApi = () => {
   const navigate = useNavigate()

   // Axios instance
   const axiosInstance = axios.create({
      baseURL: API_BASE_URL,
      headers: { 'Content-Type': 'application/json' },
   })

   // Interceptor untuk Authorization
   axiosInstance.interceptors.request.use(
      (config) => {
         if (sessionStorage.getItem('token')) {
            config.headers.Authorization = `Bearer ${sessionStorage.getItem(
               'token'
            )}`
         }
         return config
      },
      (error) => Promise.reject(error)
   )

   // Interceptor untuk handle 401 (token expired)
   axiosInstance.interceptors.response.use(
      (response) => response,
      (error) => {
         if (error.response?.status === 401) {
            sessionStorage.removeItem('token')
            alert('token expired')
            navigate('/login')
         }
         return Promise.reject(error)
      }
   )

   // GET request
   const get = async (endpoint, params = {}) => {
      try {
         const response = await axiosInstance.get(endpoint, { params })
         return response.data
      } catch (error) {
         console.error('GET Error:', error.response?.data || error.message)
         throw error
      }
   }

   // POST request
   const post = async (endpoint, data) => {
      try {
         const response = await axiosInstance.post(endpoint, data)
         return response.data
      } catch (error) {
         console.error('POST Error:', error.response?.data || error.message)
         throw error
      }
   }

   // PUT request (update)
   const put = async (endpoint, data) => {
      try {
         const response = await axiosInstance.put(endpoint, data)
         return response.data
      } catch (error) {
         console.error('PUT Error:', error.response?.data || error.message)
         throw error
      }
   }

   // DELETE request
   const remove = async (endpoint) => {
      try {
         const response = await axiosInstance.delete(endpoint)
         return response.data
      } catch (error) {
         console.error('DELETE Error:', error.response?.data || error.message)
         throw error
      }
   }

   return { get, post, put, delete: remove }
}

export const useApiExam = () => {
   // Axios instance
   const axiosInstance = axios.create({
      baseURL: API_BASE_URL,
      headers: { 'Content-Type': 'application/json' },
   })

   // Interceptor untuk Authorization
   axiosInstance.interceptors.request.use(
      (config) => {
         if (sessionStorage.getItem('exam_token')) {
            config.headers.Authorization = `Bearer ${sessionStorage.getItem(
               'exam_token'
            )}`
         }
         return config
      },
      (error) => Promise.reject(error)
   )

   // Interceptor untuk handle 401 (token expired)
   axiosInstance.interceptors.response.use(
      (response) => response,
      (error) => {
         if (error.response?.status === 401) {
            sessionStorage.removeItem('exam_token')
            alert('exam token expired')
         }
         return Promise.reject(error)
      }
   )

   // GET request
   const get_exam = async (endpoint, params = {}) => {
      try {
         const response = await axiosInstance.get(endpoint, { params })
         return response.data
      } catch (error) {
         console.error('GET Error:', error.response?.data || error.message)
         throw error
      }
   }

   // POST request
   const post_exam = async (endpoint, data) => {
      try {
         const response = await axiosInstance.post(endpoint, data)
         return response.data
      } catch (error) {
         console.error('POST Error:', error.response?.data || error.message)
         throw error
      }
   }

   // PUT request (update)
   const put_exam = async (endpoint, data) => {
      try {
         const response = await axiosInstance.put(endpoint, data)
         return response.data
      } catch (error) {
         console.error('PUT Error:', error.response?.data || error.message)
         throw error
      }
   }

   // DELETE request
   const remove_exam = async (endpoint) => {
      try {
         const response = await axiosInstance.delete(endpoint)
         return response.data
      } catch (error) {
         console.error('DELETE Error:', error.response?.data || error.message)
         throw error
      }
   }

   return { get_exam, post_exam, put_exam, delete: remove_exam }
}
